import { create } from "zustand"

export type recepcionMercaderiaProps = {
  isOpenModal: boolean,
  setIsOpenModal: (value: boolean) => void
}
export const useRecepcionMercaderia = create<recepcionMercaderiaProps>((set) => ({
  isOpenModal: false,
  setIsOpenModal(value) {

    set(() => {
      return {
        isOpenModal: value
      }
    })
  },
}))